import store from '@/store'

import { ref, watch, getCurrentInstance, computed } from '@vue/composition-api'
import { odbRequest } from '@/config/authConfig';

export default function useODB() {
    const mappingsData = ref([])
    const mappingsLoading = ref(false)
    const totalMappings = ref(0)
    
    const datamapSearch = ref('')
    const options = ref({ page: 1, itemsPerPage: 10, sortBy: ['updated_at'], sortDesc: [true] })

    const qValue = ref([])
    const qPropensityToBuy = ref([])
    const flash3Fit = ref([])

    const qValueLoading = ref(false)
    const qPropensityLoading = ref(false)
    const flash3FitLoading = ref(false)

    const genderList = ref([
        {name: "Male", id: 1},
        {name: "Female", id: 2},
        {name: "Non-Binary", id: 3},
        {name: "NA", id: 4},
    ])
    const frequencyList = ref([
        {name: "Once a week or more", id: 1},
        {name: "Once every 2 or 3 weeks", id: 2},
        {name: "Once a month", id: 3},
        {name: "Once every 2 or 3 months", id: 4},
        {name: "2 or 3 times a year", id: 5},
        {name: "Once a year", id: 6},
        {name: "Less than once a year or never", id: 7},
    ])

    const categoriesList = ref([])
    const categoriesLoading = ref(false)

    const countriesList = ref([])
    const countriesLoading = ref(false)

    const brandsList = ref([])
    const brandsLoading = ref(false)

    const clientsList = ref([])
    const clientsLoading = ref(false)
    

    const getColor = (value) => {
        if (value < 10) {
            return 'green';
        } else if (value < 30) {
            return 'blue';
        } else if (value < 50) {
            return 'orange';
        } else {
            return 'red';
        }
    }

    
    const buildTable = (data, containerId) => {


        const container = document.getElementById(containerId);
        // Clean container from potential previous norm runs.
        while (container.firstChild) {
          container.removeChild(container.lastChild);
        }
        if (data.nodata) {
          const noDataMessage = document.createElement("div");
          noDataMessage.classList.add("no-data");
          noDataMessage.textContent = "No data available.";
          container.appendChild(noDataMessage);
          return; // Exit the function early
        }


        const respBaseSpan = document.createElement("span");
        respBaseSpan.textContent = `Resp N=${data.respondent_level.base}, `;
        container.appendChild(respBaseSpan);

        const packBaseSpan = document.createElement("span");
        packBaseSpan.textContent = `Pack N=${data.pack_level.base}, `;
        container.appendChild(packBaseSpan);

        const packSmallestBaseSpan = document.createElement("span");
        packSmallestBaseSpan.textContent = `Pack Smallest N=${data.pack_level.smallest_base_value}, `;
        container.appendChild(packSmallestBaseSpan);

        const packSmallestBaseIDSpan = document.createElement("span");
        packSmallestBaseIDSpan.textContent = `Pack Smallest ID(s)=[${data.pack_level.smallest_base_id}]`;
        container.appendChild(packSmallestBaseIDSpan);

        const table = document.createElement("table");
        const thead = document.createElement("thead");
        const tbody = document.createElement("tbody");
        
        // Create Table Headers
        const superHeaderRow = document.createElement("tr");
        // Add "Question" Header
        const superQuestionHeader = document.createElement("th");
        superQuestionHeader.textContent = "Question";
        superHeaderRow.appendChild(superQuestionHeader);

        // Add "Respondents" Header
        const RespondentHeader = document.createElement("th");
        RespondentHeader.textContent = `Respondents`;
        // RespondentHeader.colSpan = 1
        superHeaderRow.appendChild(RespondentHeader);
        
        // Add "Pack" Header
        const PacktHeader = document.createElement("th");
        PacktHeader.textContent = "Packs";
        PacktHeader.colSpan = data.pack_level.pct_calculation_label.length
        superHeaderRow.appendChild(PacktHeader);

        // Create Table Headers
        const headerRow = document.createElement("tr");

        // Add "Question" Header
        const questionHeader = document.createElement("th");
        questionHeader.textContent = data.label;
        headerRow.appendChild(questionHeader);

        // Add "Respondents" Headers (Base and %)
        const respondentsBaseHeader = document.createElement("th");
        // respondentsBaseHeader.textContent = "Base";
        // headerRow.appendChild(respondentsBaseHeader);
        const respondentsPctHeader = document.createElement("th");
        respondentsPctHeader.textContent = "%";
        headerRow.appendChild(respondentsPctHeader);

        // Add "Pack" Headers (Base, Smallest Base Value, Smallest Base ID)
        const packBaseHeader = document.createElement("th");
        // packBaseHeader.textContent = "Base";
        // headerRow.appendChild(packBaseHeader);
        // const packSmallestBaseValueHeader = document.createElement("th");
        // packSmallestBaseValueHeader.textContent = "Smallest Base Value";
        // headerRow.appendChild(packSmallestBaseValueHeader);
        // const packSmallestBaseIDHeader = document.createElement("th");
        // packSmallestBaseIDHeader.textContent = "Smallest Base ID";
        // headerRow.appendChild(packSmallestBaseIDHeader);

        // Add the rest of the "Pack Level" headers
        data.pack_level.pct_calculation_label.forEach(label => {
            const th = document.createElement("th");
            th.textContent = label;
            headerRow.appendChild(th);
        });
        thead.appendChild(superHeaderRow);
        thead.appendChild(headerRow);
        table.appendChild(thead);

        // Create Table Rows
        for (let i = 0; i < data.label_pct.length; i++) {
            const row = document.createElement("tr");

            // Add "Question" Cell
            const questionCell = document.createElement("td");
            questionCell.textContent = data.label_pct[i];
            row.appendChild(questionCell);

            // Add "Respondents" Cells (Base and %)
            // const respondentsBaseCell = document.createElement("td");
            // respondentsBaseCell.textContent = data.respondent_level.base;
            // row.appendChild(respondentsBaseCell);
            const respondentsPctCell = document.createElement("td");
            respondentsPctCell.textContent = data.respondent_level.pct[i]+"%";
            // respondentsPctCell.classList.add(getColor(data.respondent_level.pct[i]));
            row.appendChild(respondentsPctCell);

            // Add "Pack" Cells (Base, Smallest Base Value, Smallest Base ID)
            // const packBaseCell = document.createElement("td");
            // packBaseCell.textContent = data.pack_level.base;
            // row.appendChild(packBaseCell);
            // const packSmallestBaseValueCell = document.createElement("td");
            // packSmallestBaseValueCell.textContent = data.pack_level.smallest_base_value;
            // row.appendChild(packSmallestBaseValueCell);
            // const packSmallestBaseIDCell = document.createElement("td");
            // packSmallestBaseIDCell.textContent = data.pack_level.smallest_base_id[0]; // Assuming only one ID
            // row.appendChild(packSmallestBaseIDCell);

            // Add the rest of the "Pack Level" data cells
            const pctRow = data.pack_level.pct[i];
            pctRow.forEach(value => {
            const cell = document.createElement("td");
            cell.textContent = value+"%";
            // const colorClass = getColor(value);
            // cell.classList.add(colorClass); // Add color class
            row.appendChild(cell);
            });

            tbody.appendChild(row);
        }

        table.appendChild(tbody);
        container.appendChild(table);
    }

    const fetchNorm = async (params, question) => {
        await store
          .dispatch('app-odb/fetchNorms', {
            ...params,
            questions:question
          })
          .then(response => {
            const { data } = response
            
            qValue.value = data
            buildTable(data[0], 'qValue-container')
            // remove loading state
            qValueLoading.value = false
          })
          .catch(error => {
            qValueLoading.value = false
            console.log(error)
          })
    }


    const fetchQValue = async (params) => {
        qValueLoading.value = true
        await store
          .dispatch('app-odb/fetchNorms', {
            ...params,
            questions:"Q_Value"
          })
          .then(response => {
            const { data } = response
            
            qValue.value = data
            buildTable(data[0], 'qValue-container')
            // remove loading state
            qValueLoading.value = false
          })
          .catch(error => {
            qValueLoading.value = false
            console.log(error)
          })
    }

    const fetchQPropensityToBuy = async (params) => {
        qPropensityLoading.value = true
        
        await store
          .dispatch('app-odb/fetchNorms', {
            ...params,
            questions:"Q_PropensityToBuy"
          })
          .then(response => {
            const { data } = response
            
            qPropensityToBuy.value = data
            buildTable(data[0], 'qPropensityToBuy-container')
            // remove loading state
            qPropensityLoading.value = false
          })
          .catch(error => {
            qPropensityLoading.value = false
            console.log(error)
          })
    }

    const fetchFlash3Fit = async (params) => {
        flash3FitLoading.value = true
        
        await store
          .dispatch('app-odb/fetchNorms', {
            ...params,
            questions:"F_FLASH3_FIT"
          })
          .then(response => {
            const { data } = response
            
            flash3Fit.value = data
            buildTable(data[0], 'flash3Fit-container')
            // remove loading state
            flash3FitLoading.value = false
          })
          .catch(error => {
            flash3FitLoading.value = false
            console.log(error)
          })
    }


    const fetchCountries = async (params) => {
      
      countriesLoading.value = true
      store
        .dispatch('app-odb/fetchCountries', {
          ...params
        })
        .then(response => {
          const { data } = response
          
          countriesList.value = data
          
          // remove loading state
          countriesLoading.value = false
        })
        .catch(error => {
          countriesLoading.value = false
          console.log(error)
        })
    }

    const fetchCategories = async (params) => {
      
      categoriesLoading.value = true
      store
        .dispatch('app-odb/fetchCategories', {
          ...params
        })
        .then(response => {
          const { data } = response
          
          categoriesList.value = data
          
          // remove loading state
          categoriesLoading.value = false
        })
        .catch(error => {
          categoriesLoading.value = false
          console.log(error)
        })
    }

    const fetchBrands = async (params) => {
      
      brandsLoading.value = true
      store
        .dispatch('app-odb/fetchBrands', {
          ...params
        })
        .then(response => {
          const { data } = response
          
          brandsList.value = data
          
          // remove loading state
          brandsLoading.value = false
        })
        .catch(error => {
          brandsLoading.value = false
          console.log(error)
        })
    }
    
    const fetchDatamap = async (params) => {
      
      return store
        .dispatch('app-odb/fetchDatamap', {
          ...params
        })
        .then(response => {
          const { data } = response
          return data
        })
        .catch(error => {
          console.log(error)
        })
    }

    const fetchDatamapMapping = async (params) => {
      return store.dispatch('app-odb/fetchDatamapMapping', params)
        .then(response => response.data)
        .catch(err => {
            if(err.response && err.response.status === 404) return null; // No saved mapping yet
            console.error(err)
            throw err
        })
    }

    const saveDatamapMapping = async (payload) => {
      return store.dispatch('app-odb/saveDatamapMapping', payload)
        .then(response => response.data)
        .catch(err => {
            console.error(err)
            throw err
        })
    }

    return {
        genderList,
        frequencyList,

        qValue,
        qValueLoading,
        flash3Fit,

        qPropensityToBuy,
        qPropensityLoading,
        flash3FitLoading,

        categoriesList,
        categoriesLoading,
        countriesList,
        countriesLoading,
        brandsList,
        brandsLoading,
        
        fetchQValue,
        fetchQPropensityToBuy,
        fetchFlash3Fit,
        fetchCountries,
        fetchCategories,
        fetchBrands,
        fetchDatamap,
        fetchDatamapMapping,
        saveDatamapMapping,
        clientsList,
        clientsLoading,
    }

}